import { clear } from 'idb-keyval'

const OWNER_KEY = 'cache-owner'

// IndexedDB holds cached pipeline data for whoever was last signed in. Wipe it
// whenever the page renders for a different user or for nobody.
export async function reconcileCacheOwner(userId: string | undefined): Promise<void> {
  let owner: string | null = null
  try {
    owner = localStorage.getItem(OWNER_KEY)
  } catch {
    // storage unavailable; treat as unknown owner
  }

  if (userId && owner === userId) return

  await clear().catch(() => {})

  try {
    if (userId) localStorage.setItem(OWNER_KEY, userId)
    else localStorage.removeItem(OWNER_KEY)
  } catch {
    // storage unavailable
  }
}
